// extracted by mini-css-extract-plugin
module.exports = {"footer__links":"footer_footer__links__1DSVF"};